import React from 'react';

function Resume() {
  return(
    <>
        <p>
            <div  style ={cT}><b >Nwachukwu Uzochukwu</b></div>
             <div class="row no-gutters">
                <div class="col no-gutters">
                    <div class="leftside">
                        <div>
                        Denton, Texas
                        </div>
                        <div>
                            www.linkedin.com/in/uzochukwu-nwachukwu 
                        </div>
                    </div>    
                </div>
                <div class="col no-gutters">
                   <div style ={rS} class="rightside">
                        <div>
                            <right>(940) 465-5871</right>
                        </div>
                        <div>
                            kinguzo2002@yahoo.com
                        </div>
                    </div>
                </div>
            </div>

            <p>
                <h4>PROFESSIONAL PROFILE</h4>
                Information System graduate with understanding of various programming languages and building databases. 
                Experienced in Manual Testing for Software Quality Assurance (SQA). Knowledgeable in Open-Source Tools 
                and Testing Methodologies (i.e. Agile, Waterfall). Familiar with Object-Oriented Programming in .Net 
                and Java. Seeking to grow knowledge and build expertise on testing strategies around manual, automation 
                and performance testing.<p/>
                <h4>TECHNICAL & KEY SKILLS</h4>
                <div class="row no-gutters">
                    <div class="col no-gutters">
                        <div class="leftside">
                            <ul>
                                <lu>• Java, JavaScript </lu><br/>
                                <lu>• MS Office 2016, 2019 </lu><br/>
                                <lu>• Visio 2019 </lu><br/>
                                <lu>• QlikView (Tableau) </lu><br/>
                                <lu>• MySQL </lu><br/>
                                <lu>• Visual Studio </lu><br/>
                                <lu>• Microsoft SQL Server 2019, IBM TN3270 </lu><br/>
                                <lu>• MS Teams </lu><br/>
                                <lu>• Windows Server 2016 </lu><br/>
                                <lu>• Atom </lu><br/>
                                <lu>• Eclipse </lu><br/>
                                <lu>• IntelliJ IDEA </lu><br/>
                                <lu>• NetBeans </lu><br/>
                                <lu>• JGRASP</lu><br/>
                                <lu>• MS Project 2016</lu><br/>
                            </ul>
                        </div>
                    </div>
                    <div class="col no-gutters">
                        <div class="rightside">
                            <ul>
                                <lu>• HP ALM </lu><br/>
                                <lu>• HTML5, IIS 7.0 </lu><br/>
                                <lu>• SQA Tools & Best Practices </lu><br/>
                                <lu>• Test Cases, Plans & Scripts </lu><br/>
                                <lu>• Defect & Bug Discovery </lu><br/>
                                <lu>• Technical Specification Analysis </lu><br/>
                                <lu>• System & Unit Testing </lu><br/>
                                <lu>• Acceptance Testing </lu><br/>
                                <lu>• Regression Testing </lu><br/>
                                <lu>• Load Testing </lu><br/>
                                <lu>• Tracking, Logging & Reporting </lu><br/>
                                <lu>• Program Logic & Optimization </lu><br/>
                                <lu>• Software Architecture Technologies </lu><br/>
                                <lu>• Issue Identification </lu><br/>
                            </ul>
                        </div>
                    </div>
                </div>
            </p>
            <h4>WORK EXPERIENCE</h4>
            <div class="row no-gutters">
                <div class="col no-gutters">
                    <div class="leftside">
                        <b>Amazon FC Associate I </b>
                    </div>
                </div> 
                Nov 2020 – Till date
            </div>
            Seasonal Fulfillment and Quality Associate<br/>
            • Shipping label creation for Amazon global package shipments<br/>
            • Item digital tracking across Amazon warehouse locations and storage units<br/>
            • Quality assurance and verification of shipment protocols<br/>
            • Shipping issue notifications, defect triage and remediation management<br/>
            <div class="row no-gutters">
                <div class="col no-gutters">
                    <div class="leftside">
                        <b>Business IT Networks LLC </b>
                    </div>
                </div>
                Jan 2015 – Nov 2020
            </div>
            QA/Test Consultant - Oracle EBS & CRM Platform Implementation<br/>
            • Performed system, acceptance, regression, load and functional/performance testing on 
            Oracle EBS and integrated systems using manual testing methods.<br/>
            • Validated, verified, communicated and resolved software issues through careful and 
            thoroughly documented testing to maximize return on investment (ROI) for IT initiatives.<br/>
            • Identified, documented and reported bugs, errors, interoperability flaws and other 
            issues within MS Dynamics CRM solution, proprietary web applications and back-end web 
            services.<br/> 
            • Performed database data validation across tables customized for the CRM platform<br/> 
            • Demonstrated methodical, detail-oriented and thorough approach to all assignments 
            while adhering to compressed timelines.<br/> 
            • Completed all assignments on or ahead of schedule.<br/> 
            • Consistently recognized for excellent problem-solving and analytical skills by 
            programmers, project managers and supervisors.<br/> 
            • Worked collaboratively with QA, development and business groups to complete 
            comprehensive testing on 2 major project releases.<br/><p/>
            <h4>EDUCATION</h4>
            <div class="row no-gutters">
                <div class="col no-gutters">
                    <div class="leftside">
                        IELI Graduation Certificate in IELI Academic Preparation 
                    </div>
                </div>
                Graduation Date: May 2015
            </div>
            University of North Texas, Denton, TX<br/>
            Bachelor of Science in Business Computer Information System<br/>
            <div class="row no-gutters">
                <div class="col no-gutters">
                    <div class="leftside">
                        University of North Texas, Denton, TX 
                    </div>
                </div>
                Graduation Date: December 2019<br/>
            </div>
            <p/>
            <h4>ACCOMPLISHMENTS</h4>
            <p>
                <div class="row no-gutters">
                    <div class="col no-gutters">
                        <div class="leftside">
                            <b>Master the Mainframe (IBM Sponsored)</b>
                        </div>
                    </div> Oct 2019 – Dec 2019
                </div>
                Completed Master the Mainframe part one and two.
                
            </p>
            <p>
                <h4>BCIS PROJECTS</h4>
                <b>Business Data Communications and Networking</b><br/>
                • Created an ERD of the University of fun Student Union Department Organization Chart<br/>
                • Created a Network and system requirement<br/>
                • Created a Physical Network design<br/>
                • Created a hardware and software requirements list<br/>
                • Created a user and groups and with their login details and group permission<br/>
                • Formed a backup and disaster plan<br/>
                • Created an implementation plan for the above project which include the timeline of the 
                implementation, installation, testing, training of the new implementation, and the 
                On-going Support afterward<br/>
                <b>Enterprise-Oriented Programming</b><br/>
                • Created a website using JavaScript<br/>
                • Created a database using MySQL<br/>
                • Ran the website on a local host Apache Tomcat<br/>
                • Functions like Update, delete where in the website that updated and delete data from the database<br/>
                <b>Analysis of Business Information Systems</b><br/>
                • Created a database using Access to record information gathered<br/>
                • Drew ER diagrams using Visio to provide a pictorial of the database information<br/>
                <b>Database Applications and Data Warehousing</b><br/>
                • Created a database using TN3270 to record information gathered<br/>
                • Drew ER diagrams using Visio to provide a pictorial of the database schema and related information<br/>
                • Created a database using MySQL to record information<br/>
                • Created a graphical representation of the database using QlikView<br/>
                <b>Web Development (Eagle Coders)</b><br/>
                • Created a non-profit business proposal as group<br/>
                • Design a business operation plan<br/>
                • Drew ER diagrams using Visio to provide a pictorial of the database schema and related information<br/>
                • Created a database using Microsoft SQL to record information<br/>
                • Built a website for the non-profit business<br/>
            </p>
            <div><h4>ORGANIZATION INVOLVEMENT</h4></div>
            <div class="row no-gutters">
                <div class="col no-gutters">
                    <div class="leftside">
                        Member of UNT Association for Information Systems
                    </div>
                </div>
                 Jan 2019 – Dec 2019 
            </div>
        </p>
    </>
  )
}

const rS = {
    textAlign: 'right',
}

const cT = {
    textAlign: 'center',
}

export default Resume;